import Tasks from 'APP/Tasks';
import { removeActiveMessageDownloads } from 'APP/Tasks/download/download';
import { GroupType } from 'APP/model/group/groupModel.types';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import Entities from 'STORE';

export function removeGroupLocally({ groupId, alert }) {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group) {
    return;
  }

  const isMlsGroup = group.type === GroupType.SecretGroup;

  if (
    Entities.GroupsStore.activeGroupId === group.id ||
    group.id === Entities.GroupsStore.activeGroup?.parentGroup?.id
  ) {
    if (alert) {
      Tasks.app.showAlert(alert);
    }
  }

  Entities.GroupsStore.rawGroups.forEach((x) => {
    if (x.parentGroup?.id === groupId) {
      Entities.Counters.delete(x.id);
      Entities.GroupsStore.delete(x.id);
      Entities.InputPanelsStore.deleteById(x.id);
      Entities.BackgroundCalls.delete(null, x.id);
      Entities.BackgroundStreams.delete(x.id);
    }
  });

  group.messagesStore.messages.forEach((message) => {
    removeActiveMessageDownloads(message.id, groupId);
  });

  Entities.Counters.delete(groupId);
  Entities.GroupsStore.delete(groupId);
  Entities.InputPanelsStore.deleteById(groupId);
  Entities.BackgroundCalls.delete(null, groupId);
  Entities.BackgroundStreams.delete(groupId);

  if (isMlsGroup) {
    MlsStorageService.deleteGroup(groupId);
  }

  if (groupId === Entities.ActiveStream?.stream?.groupId) {
    Entities.ActiveStream.reset();
  }
}
